var _module_exports = "<div>Inappropriate listing?</div>";;
var path = 'partswantedlisting/mark-spam-template.html';
window.angular.module('row52-templates').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;